import React from 'react';
import { VideoCard } from './VideoCard';
import { formVideos } from '../../data/forms';
export function VideoGrid() {
  return <section className="py-16 bg-white" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-12" data-id="element-210">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-211">
            Form Video Library
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-212">
            Watch instructional videos for each belt level form. Practice along
            with Master Mark Kanaar to perfect your technique.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-213">
          {formVideos.map(video => <VideoCard key={video.id} video={video} data-id="element-214" />)}
        </div>
      </div>
    </section>;
}